import { useAtomValue } from 'jotai'
import { FC } from 'react'
import { PropertyRecordsInfoBuildingLot } from 'src/components/insights/property-records/details/building'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { parcelPropertyRecords } from 'src/v2/state/owner-reveal/parcel-property-records'

export const ParcelBuildingLotAndLocationContent: FC = () => {
  const propertyRecords = useAtomValue(parcelPropertyRecords)

  if (!propertyRecords?.buildingAndLot) {
    return <UnavailableCardContent message="Sorry, but we couldn't find the information requested for this parcel." />
  }

  return <PropertyRecordsInfoBuildingLot buildingAndLot={propertyRecords.buildingAndLot} />
}
